import { ReactNode, createContext, useContext } from "react";

const Context = createContext({});

const vars = {
  "--header-height": "68px",
  "--header-indent": "48px",
  "--breadcrumbs-height": "24px",
  "--breadcrumbs-margin-bottom": "16px",
  "--navigation-bottom-indent": "16px",
  "--content-height":
    "calc(100vh - var(--header-height) - var(--header-indent) - var(--breadcrumbs-height) - var(--breadcrumbs-margin-bottom) - var(--navigation-bottom-indent) - var(--content-padding-bottom)",
  "--navigation-height": "var(--content-height)",
  "--aside-height": "var(--content-height)",
  "--content-padding-bottom": "32px",
};

export function VarsProvider({ children }: { children: ReactNode }) {
  return <Context.Provider value={vars}>{children}</Context.Provider>;
}

export const VarsConsumer = Context.Consumer;

export function useLayoutVars() {
  return useContext(Context);
}
